// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"Wrapper_blockWrapper__C6PWs"};